<template>
  <div id="loader">
    <div class="loading-circle"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AutoLogin',
  computed: {
    ...mapGetters({
      authenticated: 'user/authenticated',
      apiError: 'user/apiError',
    }),
  },
  watch: {
    authenticated(auth) {
      if (auth) {
        if (this.inviteToken && this.inviteToken.length) {
          this.acceptMerchantInvitation({ invite_token: this.inviteToken });
        }
        // this.fetchMerchantSubscriptions();
        this.$router.push({ name: 'logged-in-landing-page' });
      }
    },
    apiError() {
      this.throwError();
    },
  },
  mounted() {
    if (this.$route.query.token) {
      this.autologin({ token: this.$route.query.token });
    } else {
      this.throwError();
    }
  },
  methods: {
    ...mapActions({
      autologin: 'user/autologin',
      // fetchMerchantSubscriptions: 'merchant/fetchSubscriptions',
    }),
    throwError() {
      this.$router.push({
        name: 'ErrorPage',
        params: {
          title: 'Access denied.',
          error_code: 403,
          description: 'The token you have provided is invalid.',
          action_title: 'Log in',
          action_link: 'https://app.number.tm/login',
        },
      });
    },
  },
};
</script>
